import React from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';
import Quotes from './Quotes';

const Container = styled.div`
  width: 280px;
  display: flex;
  flex-direction: row;
  margin: 10px 10px 32px;
  justify-content: space-between;

  @media(min-width: 1000px) {
    margin: 10px;
  }
`;

const TextBox = styled.div`
  width: 230px;
`;

const Text = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #4a4a4a;
`;

const Author = styled(Text)`
  color: #f78323;
`;

const Company = styled(Text)`
  font-size: 14px;
  color: #999;
`;

const Testimonial = ({ testimonial }) => (
  <Container>
    <TextBox>
      <Text>{testimonial.text}</Text>
      <Author>{testimonial.author}</Author>
      <Company>{testimonial.company}</Company>
    </TextBox>
    <Quotes />
  </Container>
);

export default Testimonial;

Testimonial.propTypes = {
  testimonial: object.isRequired,
};
